module.exports = __webpack_public_path__ + "assets/img/2_805_big.5ead4dff.jpg";